/* eslint-disable no-unused-vars */
/* eslint-disable react/prop-types */
import React, { useMemo, useState, useEffect, useContext } from 'react';
import PropTypes, { object } from 'prop-types';
import { Box, Button, IconButton, Tooltip, TextField } from '@mui/material';
import {
  MaterialReactTable,
  useMaterialReactTable,
} from 'material-react-table';
import { MRT_Localization_PT_BR } from 'material-react-table/locales/pt-BR';

import {
  GetConsulta,
  GetProcesso,
  isValid,
  transformResponse,
} from 'src/services/auth';
import CustomInput from '../customInput';

import { LoadGif } from '../LoadGif';

import { ReactComponent as Select } from 'src/assets/icons/select.svg';
import { ReactComponent as Reload } from 'src/assets/icons/reload.svg';

import showToast from 'src/components/toastyService';

import { LogContext } from '../LogProvider';
import axios from 'axios';

export default function SearchTable({
  webservice,
  SetSearch,
  Titulo,
  extraData,
  extraExtraData,
  defaultData,
  onClose,
}) {
  const { setLogData } = useContext(LogContext);
  const idEmp = localStorage.getItem('idEmp');

  const [load, setLoad] = useState(true);

  const [result, setResult] = useState('');
  const [colunas, setColunas] = useState([]);
  const [tableData, setTableData] = useState([]);
  const [showParameters, setShowParameters] = useState(false);
  const [showErro, setShowErro] = useState([]);
  const [parameters, setParameters] = useState({});

  const [searchform, setSearchForm] = useState({});

  const porta = webservice?.endpoint.porta;
  const url = webservice?.endpoint.url;
  const [isCache, setIsCache] = useState(false);

  const [usouCache, setUsouCache] = useState(false);

  function consulta(cache, parametros) {
    setLoad(true);
    setShowParameters(false);
    const empUrl = localStorage.getItem('empUrl');

    const idEmp = localStorage.getItem('idEmp');
    const idFil = localStorage.getItem('idFil');

    if (webservice.tipo === 'webservice') {
      const data = {
        codemp: extraData?.codemp || idEmp,
        codfil: extraData?.codfil || idFil,
        tipAca: 'C',
        ...parametros,
      };

      const trimmedUrl = webservice.endpoint.url.trim();
      const thisUrl = isValid(trimmedUrl) ? url : `${empUrl}_gestao_consultas`;

      GetConsulta(thisUrl, porta, data, cache)
        .then((response) => {
          const res = response[0];
          setUsouCache(response[1]);

          setResult(res);

          const myData = Array.isArray(res?.dadosGerais)
            ? res?.dadosGerais
            : [res?.dadosGerais];
          setTableData(myData);

          const resultColunas = res
            ? Object.entries(res)
                .filter(([key]) => key.toLowerCase().includes('colunas'))
                .map(([, value]) => value)[0]
            : undefined;

          const colunasJson = resultColunas && JSON.parse(resultColunas);

          setColunas(colunasJson?.Dados);

          setIsCache(res?.cache);

          const erro = res?.erroExecucao;
          if (isValid(erro)) setShowErro(erro);
        })
        .finally((res) => {
          setTimeout(() => {
            setLoad(false);
          }, 200);
        });
    }
  }
  function consultaModular(parametros) {
    const finalUrl = url.replace(
      /\(([^)]+)\)/g,
      (_, key) => parametros[key] || ''
    );

    //https://thingproxy.freeboard.io/fetch/
    const proxyUrl = `${finalUrl}`;

    axios
      .get(proxyUrl)
      .then((res) => {
        SetSearch(res.data);
      })
      .catch((erro) => {
        const mensagemErro =
          erro?.response?.data || erro.message || 'Erro desconhecido';
        showToast('error', mensagemErro);
        setLoad(false);
        onClose();
      })
      .finally(() => {
        setLoad(false);
      });
  }

  useEffect(() => {
    if (webservice.tipo === 'webservicemodulo') {
      const thisPorta = webservice.endpoint.porta;

      setLoad(false);
      setShowParameters(true);
      setParameters({
        [thisPorta]: {
          nome: thisPorta,
          tipo: 'string',
        },
      });
    }

    if (webservice.tipo === 'webservice') {
      if (result === '') {
        if (!Object.keys(webservice.endpoint).includes('parametros')) {
          setLoad(false);
          if (isValid(porta)) {
            consulta(true);
          }
        } else {
          setTimeout(() => {
            setLoad(false);
          }, 200);

          setShowParameters(true);
          setParameters(webservice.endpoint.parametros);
        }
      }
    }

    //-----MONTAR-FORMULARIO
    setSearchForm(
      Object.keys(parameters)?.reduce((acc, key) => {
        const value = extraData[key] || extraExtraData[key];

        acc[key] = value;
        return acc;
      }, {})
    );
  }, []);

  const data = useMemo(() => {
    if (!Array.isArray(tableData)) return [];

    return tableData.filter((row) => row && typeof row === 'object');
  }, [tableData]);

  const columns = useMemo(() => {
    if (!colunas || typeof colunas !== 'object') return [];

    return Object.entries(colunas)
      .filter(([key, item]) => key !== 'titulo')
      .map(([key, item]) => ({
        accessorKey: key,
        header: item?.nome || key,
      }));
  }, [colunas]);

  const subFormTable = useMaterialReactTable({
    columns,
    data,
    initialState: { showGlobalFilter: true, density: 'compact' },

    enableRowSelection: false,
    enableColumnOrdering: false,
    enableGlobalFilter: true,
    enableSorting: false,
    enablePagination: false,
    enableBottomToolbar: false,
    enableTopToolbar: true,
    enableColumnActions: false,
    enableEditing: true,

    enableStickyHeader: false,
    rowPinningDisplayMode: 'top-and-bottom',
    enableFullScreenToggle: false,

    muiToolbarAlertBannerProps: {
      sx: {
        backgroundColor: 'transparent',
        color: '#146b7c',
      },
    },

    muiTableContainerProps: {
      sx: { height: '40vh', width: '100%' },
    },

    muiTableBodyCellProps: ({ cell }) => ({
      style: { cursor: 'pointer' },
    }),
    muiTableBodyRowProps: ({ row, staticRowIndex, table }) => ({
      onClick: (event) => {
        SetSearch(row.original);
      },
      sx: { cursor: 'pointer' },
    }),

    muiTablePaperProps: {
      sx: {
        boxShadow: 'none',
      },
    },

    renderRowActions: ({ row, table }) => (
      <Box sx={{ display: 'flex', gap: '1rem' }}>
        <Tooltip title="Selecionar">
          <IconButton>
            <Select className="tableIcon stroke" />
          </IconButton>
        </Tooltip>
      </Box>
    ),

    localization: MRT_Localization_PT_BR,
  });

  useEffect(() => {
    if (Object.entries(parameters).length > 0) {
      const updatedSearchForm = {};
      let canConsult = true;

      Object.entries(parameters).forEach(([key, value]) => {
        let valor = null;

        if (defaultData && isValid(defaultData[key])) {
          valor = defaultData[key];
        }

        if (extraData && isValid(extraData[key])) {
          valor = extraData[key];
        }

        if (extraExtraData && isValid(extraExtraData[key])) {
          valor = extraExtraData[key];
        }

        if (valor !== '' && valor !== null && valor !== undefined) {
          updatedSearchForm[key] = valor;
        } else {
          canConsult = false;
        }
      });

      setSearchForm((prev) => ({ ...prev, ...updatedSearchForm }));

      if (canConsult) {
        if (webservice.tipo === 'webservice') consulta(true, updatedSearchForm);
        else if (webservice.tipo === 'webservicemodulo') {
          consultaModular(updatedSearchForm);
        }
      }
    }
  }, [extraData, parameters]);

  return (
    <span
      className="searchTable"
      style={{ backgroundColor: usouCache ? '#e9e9e9' : '#fff' }}
    >
      {load && <LoadGif />}

      {!load && (
        <h3>
          Selecionar {Titulo}
          <button
            className="reload mainButton turquoise"
            onClick={() => consulta(false, searchform)}
          >
            <Reload /> Recarregar
          </button>
        </h3>
      )}

      {showParameters && !load && (
        <>
          {Object.entries(parameters).map(([key, value], index) => {
            let valor = null;

            if (defaultData && isValid(defaultData[key])) {
              valor = defaultData[key];
            }

            if (extraData && isValid(extraData[key])) {
              valor = extraData[key];
            }

            if (extraExtraData && isValid(extraExtraData[key])) {
              valor = extraExtraData[key];
            }

            return (
              <div key={index}>
                <CustomInput
                  PlaceHolder={value.nome}
                  OnChange={(e) =>
                    setSearchForm((prev) => ({
                      ...prev,
                      [key]: e.target.value,
                    }))
                  }
                  DefaultValue={valor || ''}
                  Disabled={valor != null && valor != ''}
                />
              </div>
            );
          })}

          <div className="list">
            <button className="mainButton red" onClick={onClose}>
              retornar
            </button>
            <button
              className="mainButton turquoise"
              onClick={() => {
                if (webservice.tipo === 'webservice')
                  consulta(true, searchform);
                else if (webservice.tipo === 'webservicemodulo') {
                  consultaModular(searchform);
                }
              }}
            >
              Consultar
            </button>
          </div>
        </>
      )}

      {!showParameters && !isValid(showErro) && !load && (
        <div>
          <Box
            sx={{
              width: '100%',
              border: '1px solid lightgray',
              marginBottom: '20px',
              minWidth: '35vw',
            }}
          >
            <MaterialReactTable table={subFormTable} />
          </Box>
          <div className="list">
            <button className="mainButton red" onClick={onClose}>
              retornar
            </button>
          </div>
        </div>
      )}

      {isValid(showErro) && !load && (
        <>
          <h6>{showErro}</h6>
          <div className="list">
            <button className="mainButton red" onClick={onClose}>
              retornar
            </button>
          </div>
        </>
      )}
    </span>
  );
}

SearchTable.propTypes = {
  SetSearch: PropTypes.func.isRequired,
  colunas: PropTypes.object,
  tableData: PropTypes.array,
  webservice: PropTypes.object,
  Titulo: PropTypes.string,
  extraData: PropTypes.object,
  extraExtraData: PropTypes.object,
  defaultData: PropTypes.object,
};
